import classNames from 'classnames';
import fp from 'lodash/fp';
import React from 'react';
import { Row } from 'react-bootstrap';
import { FiCheck } from 'react-icons/fi';
import { lifecycle, withHandlers, withStateHandlers } from 'recompose';
import { compose } from 'redux';
import ToggleBox from '../../toggle-box';

const ContentBookmarkFilter = ({
  isBookmarkedOnly,
  onIsBookmarkedOnlyChange,
}) => (
    <div className='filter content-type-filter'>
      <Row className='no-gutter'>
        <div>
          <form id='selection-list'>
            <div>
              <Row
                className={classNames('no-gutter', { selected: isBookmarkedOnly })}
                id='selection'
                key='isBookmarkedOnly'
                onClick={() => onIsBookmarkedOnlyChange(!isBookmarkedOnly)}
              >
                <span id='checkbox'>
                  <ToggleBox
                    small
                    value={isBookmarkedOnly}
                    label={isBookmarkedOnly ? <FiCheck /> : null}
                    checked={isBookmarkedOnly} />
                </span>
                <span>Bookmark Only</span>
              </Row>
            </div>
          </form>
        </div>
      </Row>
    </div>
  )

export default compose(
  withStateHandlers(
    {
      isBookmarkedOnly: false
    },
    {
      setIsBookmarkedOnly: () => (isBookmarkedOnly) => ({
        isBookmarkedOnly
      }),
      resetIsBookmarkedOnly: () => ({ isBookmarkedOnly }) => ({
        isBookmarkedOnly
      })
    }
  ),
  withHandlers({
    onIsBookmarkedOnlyChange: ({ onChange, setIsBookmarkedOnly }) => (newIsBookmarkedOnly) => {
      setIsBookmarkedOnly(newIsBookmarkedOnly)
      onChange({
        isBookmarkedOnly: newIsBookmarkedOnly
      });
    }
  }),
  lifecycle({
    componentDidUpdate(prevStat) {
      const { filter, resetIsBookmarkedOnly } = this.props
      if (!fp.isEqual(filter)(prevStat.filter)) {
        resetIsBookmarkedOnly(filter)
      }
    }
  })
)(ContentBookmarkFilter)


// WEBPACK FOOTER //
// ./src/containers/components/filters/partials/content-bookmark-filter.js